import { gql } from '@apollo/client';

export const termFragments = {
  termViewItem: gql`
    fragment TermViewItem on TermView {
      id
      projectId
      parentId
      tag
      isCableOrJumper
      sequenceNumber
      wireColor
      fromWire
      fromEquipmentTag
      fromBlockTag
      fromPointTag
      fromSide
      fromVendorCount
      fromCustomerCount
      toWire
      toEquipmentTag
      toBlockTag
      toPointTag
      toSide
      toVendorCount
      toCustomerCount
      description
    }
  `,
  jumperTermItem: gql`
    fragment JumperTermItem on JumperTerm {
      id
      projectId
      parentId
      sequenceNumber
      fromWire
      fromEquipmentId
      fromEquipmentBlockPointId
      fromSide
      fromCode
      toWire
      toEquipmentId
      toEquipmentBlockPointId
      toSide
      toCode
      description
      colorSequenceNumber
      updatedTime
      updatedBy
      isRestricted
      wireColor
      jumperTermView {
        id
        projectId
        jumperTag
        wireColor
        fromEquipmentTag
        fromBlockTag
        fromPointTag
        fromVendorCount
        fromCustomerCount
        toEquipmentTag
        toBlockTag
        toPointTag
        toVendorCount
        toCustomerCount
      }
    }
  `,
  cableTermItem: gql`
    fragment CableTermItem on CableTerm {
      id
      projectId
      parentId
      sequenceNumber
      fromWire
      fromEquipmentId
      fromEquipmentBlockPointId
      fromSide
      fromCode
      toWire
      toEquipmentId
      toEquipmentBlockPointId
      toSide
      toCode
      description
      colorSequenceNumber
      updatedTime
      updatedBy
      isRestricted
      wireColor
      cableTermView {
        id
        projectId
        cableTag
        wireColor
        fromEquipmentTag
        fromBlockTag
        fromPointTag
        fromVendorCount
        fromCustomerCount
        toEquipmentTag
        toBlockTag
        toPointTag
        toVendorCount
        toCustomerCount
      }
    }
  `,
  commodityTermItem: gql`
    fragment CommodityTermItem on CommodityTerm {
      id
      parentId
      sequenceNumber
      wireColor
      fromWire
      fromEquipmentId
      fromBlockTag
      fromPointTag
      fromSide
      fromCode
      toWire
      toEquipmentId
      toBlockTag
      toPointTag
      toSide
      toCode
      description
      colorSequenceNumber
    }
  `,
};

export const SAVE_CABLE_TERMS = gql`
  ${termFragments.cableTermItem}
  mutation SaveCableTerms($saveCableTermInput: SaveCableTermInput!) {
    saveCableTerms(saveCableTermInput: $saveCableTermInput) {
      cable {
        id
        projectId
        fromTermSecondaryStatus
        fromTermPrimaryStatus
        fromTermHoldStatus
        fromTermRevision
        fromTermEngrStatus
        fromTermCardRev
        fromTermConstStatus
        fromTermUpdatedTime
        fromTermUpdatedByUser {
          id
          nameFirst
          nameLast
        }
        fromTermUpdatedBy
        toTermSecondaryStatus
        toTermPrimaryStatus
        toTermHoldStatus
        toTermRevision
        toTermEngrStatus
        toTermCardRev
        toTermConstStatus
        toTermUpdatedTime
        toTermUpdatedBy
        toTermUpdatedByUser {
          id
          nameFirst
          nameLast
        }
        cableView {
          id
          hasTerms
        }
        terms {
          ...CableTermItem
        }
      }
      errors {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
      infos {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
    }
  }
`;

export const GET_FIRST_EQUIPMENT_TAG_IN_LOOP = gql`
  query FirstEquipmentTagInLoop($equipmentTag: String!, $blockTag: String!, $pointTag: String!) {
    firstEquipmentTagInLoop(equipmentTag: $equipmentTag, blockTag: $blockTag, pointTag: $pointTag)
  }
`;
export const GET_CABLE_TERMS_BY_CABLE_ID = gql`
  ${termFragments.cableTermItem}
  query CableById($id: ID!) {
    cableById(id: $id) {
      id
      projectId
      tag
      fromTermPrimaryStatus
      fromTermSecondaryStatus
      fromTermConstStatus
      fromTermHoldStatus
      fromTermRevision
      fromTermCardRev
      fromTermUpdatedBy
      fromTermUpdatedTime
      fromTermUpdatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      fromTermEngrStatus
      toTermPrimaryStatus
      toTermSecondaryStatus
      toTermConstStatus
      toTermHoldStatus
      toTermRevision
      toTermCardRev
      toTermUpdatedBy
      toTermUpdatedTime
      toTermUpdatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
      toTermEngrStatus
      cableCodeId
      cableCode {
        id
        tag
      }
      cableFromEnds {
        id
        cableId
        equipmentId
        equipment {
          id
          tag
        }
      }
      cableToEnds {
        id
        cableId
        equipmentId
        equipment {
          id
          tag
        }
      }
      terms {
        ...CableTermItem
      }
    }
  }
`;

export const GET_JUMPER_TERMS_BY_JUMPER_ID = gql`
  ${termFragments.jumperTermItem}
  query JumperById($id: ID!) {
    jumperById(id: $id) {
      id
      projectId
      tag
      engineeringStatus
      secondaryStatus
      cableCodeId
      cableCode {
        id
        tag
      }
      fromEquipmentId
      toEquipmentId
      fromEquipment {
        id
        tag
      }
      toEquipment {
        id
        tag
      }
      terms {
        ...JumperTermItem
      }
      updatedBy
      updatedTime
      updatedByUser {
        id
        nameFirst
        nameLast
        userAccountPhoto {
          id
          photo
        }
      }
    }
  }
`;

export const GET_TERMS_BY_EQUIPMENT_ID = gql`
  ${termFragments.cableTermItem}
  ${termFragments.jumperTermItem}
  query equipmentTermByEquipmentId($id: ID!) {
    equipmentTermByEquipmentId(id: $id) {
      cableTerms {
        ...CableTermItem
        parent {
          id
          tag
          fromTermSecondaryStatus
          fromTermEngrStatus
          toTermSecondaryStatus
          toTermEngrStatus
          isRestricted
          cableFromEnds {
            id
            equipment {
              id
              tag
            }
          }
          cableToEnds {
            id
            equipment {
              id
              tag
            }
          }
        }
      }
      jumperTerms {
        ...JumperTermItem
        parent {
          id
          tag
          secondaryStatus
          engineeringStatus
          isRestricted
          fromEquipmentId
          fromEquipment {
            id
            tag
          }
          toEquipmentId
          toEquipment {
            id
            tag
          }
        }
      }
    }
  }
`;

export const SAVE_EQUIPMENT_TERMS = gql`
  ${termFragments.cableTermItem}
  ${termFragments.jumperTermItem}
  mutation SaveEquipmentTerms($saveEquipmentTermInput: SaveEquipmentTermInput!) {
    saveEquipmentTerms(saveEquipmentTermInput: $saveEquipmentTermInput) {
      cables {
        id
        projectId
        cableView {
          id
          hasTerms
        }
        terms {
          ...CableTermItem
          parent {
            id
            tag
            fromTermPrimaryStatus
            fromTermSecondaryStatus
            fromTermEngrStatus
            fromTermHoldStatus
            fromTermRevision
            fromTermCardRev
            fromTermUpdatedTime
            fromTermUpdatedBy
            fromTermUpdatedByUser {
              id
              nameFirst
              nameLast
              userAccountPhoto {
                id
                photo
              }
            }
            toTermPrimaryStatus
            toTermSecondaryStatus
            toTermEngrStatus
            toTermHoldStatus
            toTermRevision
            toTermCardRev
            toTermUpdatedTime
            toTermUpdatedBy
            toTermUpdatedByUser {
              id
              nameFirst
              nameLast
              userAccountPhoto {
                id
                photo
              }
            }
            isRestricted
            cableFromEnds {
              id
              equipment {
                id
                tag
              }
            }
            cableToEnds {
              id
              equipment {
                id
                tag
                equipmentView {
                  id
                  hasTerms
                }
              }
            }
          }
        }
      }
      jumpers {
        id
        jumperView {
          id
          hasTerms
        }
        terms {
          ...JumperTermItem
          parent {
            id
            tag
            primaryStatus
            secondaryStatus
            engineeringStatus
            holdStatus
            engineeringStatus
            isRestricted
            fromEquipmentId
            fromEquipment {
              id
              tag
            }
            toEquipmentId
            toEquipment {
              id
              tag
            }
          }
        }
        updatedBy
        updatedTime
        updatedByUser {
          id
          nameFirst
          nameLast
          userAccountPhoto {
            id
            photo
          }
        }
      }
      errors {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
      infos {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
    }
  }
`;

export const SAVE_JUMPER_TERMS = gql`
  ${termFragments.jumperTermItem}
  mutation SaveJumperTerms($saveJumperTermInput: SaveJumperTermInput!) {
    saveJumperTerms(saveJumperTermInput: $saveJumperTermInput) {
      jumper {
        id
        primaryStatus
        secondaryStatus
        holdStatus
        engineeringStatus
        fromEquipmentId
        fromEquipment {
          id
          tag
        }
        toEquipmentId
        toEquipment {
          id
          tag
        }
        jumperView {
          id
          hasTerms
        }
        terms {
          ...JumperTermItem
        }
        updatedBy
        updatedTime
        updatedByUser {
          id
          nameFirst
          nameLast
          userAccountPhoto {
            id
            photo
          }
        }
      }
      errors {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
      infos {
        __typename
        ... on ErrorKey {
          key
        }
        ... on ServerMessage {
          messageKey
          message
          alternateMessage
        }
      }
    }
  }
`;

export const VIEW_TERMS = gql`
  ${termFragments.termViewItem}
  query SearchTermView($searchInput: SearchInput) {
    searchTermView(searchInput: $searchInput) {
      items {
        ...TermViewItem
      }
    }
  }
`;

export const ISSUE_CABLE_TERMS = gql`
  mutation IssueCableTerms($issueCableTermsInput: IssueCableTermsInput!) {
    issueCableTerms(issueCableTermsInput: $issueCableTermsInput) {
      cables {
        id
        fromTermPrimaryStatus
        toTermPrimaryStatus
        fromTermEngrStatus
        toTermEngrStatus
        fromTermCardRev
        toTermCardRev
        fromTermUpdatedBy
        toTermUpdatedBy
        fromTermRevision
        toTermRevision
        fromTermSecondaryStatus
        toTermSecondaryStatus
      }
      errors {
        messageKeys
        tag
      }
    }
  }
`;

export const COPY_TERMS = gql`
  ${termFragments.commodityTermItem}
  mutation CopyTerms($copyTermInput: CopyTermInput!) {
    copyTerms(copyTermInput: $copyTermInput) {
      errors
      terms {
        ...CommodityTermItem
      }
    }
  }
`;
